<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('qualitycheck.distributor.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.emailSupport"
            :error-messages="emailSupportErrors"
            :label="$t('qualitycheck.distributor.emailsupport')"
            required
            @input="$v.item.emailSupport.$touch()"
            @blur="$v.item.emailSupport.$touch()"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-textarea
            v-model="item.comment"
            :error-messages="commentErrors"
            :label="$t('qualitycheck.distributor.comment')"
            auto-grow
            rows="1"
            row-height="15"
            @input="$v.item.comment.$touch()"
            @blur="$v.item.comment.$touch()"
          />
        </v-col>
      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Loading from '../../components/Loading';

export default {
  name: 'DistributorForm',
  mixins: [validationMixin],
  components: {
    Loading,
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {

  },
  data() {
    return {
        name: null,
        emailSupport: null,
        comment: null,

    };
  },
  computed: {
    isLoading() {
      return (
      false
       );
    },

    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];

      if (!this.$v.item.name.$dirty) return errors;

      has(this.violations, 'name') && errors.push(this.violations.name);

      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    emailSupportErrors() {
      const errors = [];

      if (!this.$v.item.emailSupport.$dirty) return errors;

      has(this.violations, 'emailSupport') && errors.push(this.violations.emailSupport);

      !this.$v.item.emailSupport.required && errors.push(this.$t('global.field_required'));

      return errors;
    },
    commentErrors() {
      const errors = [];

      if (!this.$v.item.comment.$dirty) return errors;

      has(this.violations, 'comment') && errors.push(this.violations.comment);


      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {

  },
  validations: {
    item: {
      name: {
        required,
      },
      emailSupport: {
        required,
      },
      comment: {

      },
    }
  }
};
</script>
